<ion-app>
    <app-nav-menu></app-nav-menu>
    <ion-router-outlet id="main-content"> </ion-router-outlet>
</ion-app>
